module.exports = __webpack_public_path__ + "static/media/48@2x.1e097a8a.png";